// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jdvA","top":"styles_top__2tbCX"};